import * as _ from "lodash";
import {Pipe, PipeTransform} from "@angular/core";

@Pipe({
    name: "dataFilter"
})
export class DataFilterPipe implements PipeTransform {

    transform(array, query: string): any {

        if (query) {
            /*return _.filter(array, function(item){
              return item.norma.indexOf(query) > -1;

            });*/
            let text = _.toLower(query);
            return _.filter(array, function(object) {
              return _(object).some(function(string) {
                let aux = _.toLower(string);
                return _(aux).includes(text);
              });
            });
            //return _.includes(array, query);
        }
        return array;
    }
}



// WEBPACK FOOTER //
// ./src/app/_models/data-filter.pipe.ts